import { CContainer } from '@coreui/react-pro';
import React, { Suspense } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import BreadCrumbRouter from '../../components/General/BreadCrumbRouter';

// routes config
import CenterSpinner from '../../components/General/Loadings/CenterSpinner';
import { LOCAL_ORG_USER, SUBSCRIBER_PATH } from '../../constants';
import { organizationRoutes, subscriberRoutes } from '../../routes';
import { tryParseJSON } from '../../utils';

const OrgContent = () => {
     const location = useLocation();
     const activeOrganizationOwner = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     let routes = subscriberRoutes;

     if (activeOrganizationOwner) {
          routes = organizationRoutes;
     }
     const element = useRoutes(routes);
     const checkShowBreadCrumb = location.pathname !== SUBSCRIBER_PATH.ORGANIZATIONS_DASHBOARD;

     return (
          <main className="c-main">
               {checkShowBreadCrumb && (
                    <CContainer className="container-breadcrum-org">
                         <div className="container-content">
                              <BreadCrumbRouter routes={organizationRoutes} />
                         </div>
                    </CContainer>
               )}
               <Suspense fallback={<CenterSpinner classNameWrap="page-loading-top" />}>{element}</Suspense>
          </main>
     );
};

export default OrgContent;
